import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

type StatusFilter = 'all' | 'active' | 'archived';

type Params = {
  topicId: string;
  status: StatusFilter;
  search: string;
  page: number;
  perPage: number;
};

async function fetchSubTopicListPaged(params: Params) {
  const from = (params.page - 1) * params.perPage;
  const to = from + params.perPage - 1;

  let query = apiClient
    .from('sub_topics')
    .select('*', { count: 'exact' })
    .eq('topic_id', params.topicId)
    .order('name', { ascending: true })
    .range(from, to);

  if (params.status === 'active') {
    query = query.is('archived_at', null);
  } else if (params.status === 'archived') {
    query = query.not('archived_at', 'is', null);
  }

  const search = params.search.trim();
  if (search) {
    query = query.ilike('name', `%${search}%`);
  }

  const { data, error, count } = await query;

  if (error) {
    throw error;
  }

  return { rows: data ?? [], total: count ?? 0 };
}

export function useGetSubTopicListPaged(params: Params) {
  return useQuery({
    queryKey: keys.subTopicListPaged(params.topicId, params.status, params.search, params.page, params.perPage),
    queryFn: () => fetchSubTopicListPaged(params),
    enabled: !!params.topicId,
    placeholderData: keepPreviousData,
  });
}
